import { render, staticRenderFns } from "./chineseJournals.vue?vue&type=template&id=7f7bd55e&scoped=true"
import script from "./chineseJournals.vue?vue&type=script&lang=js"
export * from "./chineseJournals.vue?vue&type=script&lang=js"
import style0 from "./chineseJournals.vue?vue&type=style&index=0&id=7f7bd55e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7bd55e",
  null
  
)

export default component.exports